const SET_CARDS = (state, data) => {
  state.created = new Date().toString()
  state.cards = data
}

const SAVE_PAYMENT_METHOD_SUBMIT = (state, data) => {
  state.savePaymentMethodProgress = true
  state.savePaymentMethodStateCheckCounter = -1
  state.savePaymentMethodState = 'SUBMITTED'
  state.savePaymentMethodOrderId = null
  state.savePaymentMethodErrorMessage = null
  state.savePaymentMethod3DSChallange = null
  state.savePaymentMethodWaitingAfterChallange = false
}

const SET_WAITING_AFTER_3DS_CHALLANGE = (state, waiting) => {
  state.savePaymentMethodWaitingAfterChallange = waiting
}

const SAVE_PAYMENT_METHOD_ERROR = (state, message) => {
  state.savePaymentMethodProgress = false
  if (message) state.savePaymentMethodErrorMessage = message
  state.savePaymentMethodState = 'ERROR'
}

const SAVE_PAYMENT_METHOD_TIMEOUT = (state, data) => {
  state.savePaymentMethodProgress = false
  state.savePaymentMethodState = 'TIMEOUT'
}

const GET_SAVE_PAYMENT_METHOD_STATE_CHECK_COUNTER_INCREASE = (state, data) => {
  state.savePaymentMethodStateCheckCounter++
}

const SAVE_PAYMENT_METHOD_SET_STATE = (state, data) => {
  state.savePaymentMethodState = data
}

const SAVE_PAYMENT_METHOD_SET_ORDER_ID = (state, orderId) => {
  state.savePaymentMethodOrderId = orderId
}

const SAVE_PAYMENT_METHOD_SUCCESS = (state, data) => {
  state.savePaymentMethodProgress = false
  state.savePaymentMethodState = 'COMPLETED'
  state.recurringDetailId = data.recurringDetailId
}

const SAVE_PAYMENT_METHOD_RESET = (state) => {
  state.savePaymentMethodState = 'RESET'
  state.savePaymentMethodProgress = false
  state.savePaymentMethodOrderId = null
  state.savePaymentMethod3DSChallange = null
  state.savePaymentMethodWaitingAfterChallange = false
}

const SAVE_PAYMENT_METHOD_3D_SECURE_CHALLANGE = (state, data) => {
  state.savePaymentMethod3DSChallange = data
}

const EDIT_PAYMENT_METHOD_SUBMIT = (state) => {
  state.editPaymentMethodProgress = true
  state.editPaymentMethodState = 'IN_PROGRESS'
}

const EDIT_PAYMENT_METHOD_SET_STATE = (state, value) => {
  state.editPaymentMethodState = value
}

const EDIT_PAYMENT_METHOD_ERROR = (state, reason) => {
  state.editPaymentMethodProgress = false
  state.editPaymentMethodState = reason || 'ERROR'
}

const EDIT_PAYMENT_METHOD_SUCCESS = (state) => {
  state.editPaymentMethodProgress = false
  state.editPaymentMethodState = 'COMPLETED'
}

const GET_AUTO_TOP_UPS_SUBMIT = (state) => {
  state.getAutoTopUpsProgress = true
  state.getAutoTopUpsState = 'IN_PROGRESS'
}

const GET_AUTO_TOP_UPS_SUCCESS = (state, data) => {
  state.autoTopUps = data
  state.getAutoTopUpsProgress = false
  state.getAutoTopUpsState = 'COMPLETED'
}

const SET_AUTO_TOP_UP_SUBMIT = (state) => {
  state.autoTopUpProgress = true
  state.autoTopUpState = 'IN_PROGRESS'
}

const GET_AUTO_TOP_UPS_ERROR = (state, reason) => {
  state.getAutoTopUpsProgress = false
  state.getAutoTopUpsState = reason || 'ERROR'
}

const SET_AUTO_TOP_UP_SET_STATE = (state, value) => {
  state.autoTopUpState = value
}

const SET_AUTO_TOP_UP_ERROR = (state, reason) => {
  state.autoTopUpProgress = false
  state.autoTopUpState = reason || 'ERROR'
}

const SET_AUTO_TOP_UP_SUCCESS = (state) => {
  state.autoTopUpProgress = false
  state.autoTopUpState = 'COMPLETED'
}

export default {
  SET_CARDS,
  SAVE_PAYMENT_METHOD_SUBMIT,
  SAVE_PAYMENT_METHOD_ERROR,
  GET_SAVE_PAYMENT_METHOD_STATE_CHECK_COUNTER_INCREASE,
  SAVE_PAYMENT_METHOD_SET_ORDER_ID,
  SAVE_PAYMENT_METHOD_SET_STATE,
  SAVE_PAYMENT_METHOD_SUCCESS,
  SAVE_PAYMENT_METHOD_TIMEOUT,
  SAVE_PAYMENT_METHOD_RESET,
  SAVE_PAYMENT_METHOD_3D_SECURE_CHALLANGE,
  SET_WAITING_AFTER_3DS_CHALLANGE,
  EDIT_PAYMENT_METHOD_SUBMIT,
  EDIT_PAYMENT_METHOD_SET_STATE,
  EDIT_PAYMENT_METHOD_ERROR,
  EDIT_PAYMENT_METHOD_SUCCESS,
  GET_AUTO_TOP_UPS_SUBMIT,
  GET_AUTO_TOP_UPS_SUCCESS,
  GET_AUTO_TOP_UPS_ERROR,
  SET_AUTO_TOP_UP_SUBMIT,
  SET_AUTO_TOP_UP_SET_STATE,
  SET_AUTO_TOP_UP_ERROR,
  SET_AUTO_TOP_UP_SUCCESS
}



// WEBPACK FOOTER //
// ./src/store/modules/user/wallet/mutations.js